import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { db } from '../config/firebase'
import {Helmet} from "react-helmet"

function Book(props) {

    let { book_id, insight_name } = useParams()
    const location = useLocation()

    const [book, setBook] = useState(null)

    useEffect(() => {
        let mounted = true
        db.collection('books').doc(book_id).get()
        .then(doc => {
            setBook(doc.data())
        })
        function cleanup() {
            mounted = false
        }
    }, [])

    return (
        <div>
            <Helmet>
                <meta charset="utf-8" />
                <title>{book.title}</title>
                <meta name="description" content='Check out this book at PangoBooks' />
                <link rel="canonical" href={`https://pangobooks.com${location.pathname}`} />
                {/* FB Tags */}
                <meta name="og:url" content={`https://pangobooks.com${location.pathname}`} />
                <meta name="og:title" content={book.title} />
                <meta name="og:description" content={'Check out this book at PangoBooks'} />
                <meta name="og:image" content={book.photo_url} />
                <meta name="og:type" content="website" />
            </Helmet>
            <img src={book.photo_url} width='30%' />
        </div>
    )
}

export default Book